import React from 'react';
import styled from 'styled-components';

import { capitalize } from 'helpers/string';

const UnloadingMethodWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const UnloadingMethodCompactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const UnloadingMethodText = styled.span`
  color: #FADB14;
  font-size: 3.6vw;
  font-weight: 800;
  max-width: 14ch;
  white-space: normal;
  vertical-align: middle;
  line-height: 1.1;
`;

const UnloadingMethodCompactText = styled.span`
  color: #FFFFFF;
  font-size: 1.5vw;
  font-weight: 700;
  line-height: 1.1;
  width: 100%;
  text-align: center;
`;

const UnloadingMethodCompactTitle = styled.span`
  display: block;
  // color: #FFFFFF;
  color: #B9C2C9;
  font-weight: 600;
  // font-size: 1.3vw;
  font-size: 1.6vw;
  // line-height: 1.1;
  line-height: 1.3;
  width: 100%;
  text-align: center;
  margin-bottom: 1.6vh;
`;

const UnloadingImg = styled.img`
  display: block;
  height: 10vh;
  margin-bottom: 2vh;
`;

const UnloadingMethod = ({ imgSrc, method, styles = {} }) => {
  return (
    <UnloadingMethodWrapper style={styles.wrapper || {}}>
      <UnloadingImg src={imgSrc} alt={method} style={styles.img} />
      <UnloadingMethodText style={styles.text}>
        Unloading with {capitalize(method)}
      </UnloadingMethodText>
    </UnloadingMethodWrapper>
  );
};

export const UnloadingMethodCompact = ({ imgSrc, title, method, styles = {},isLoad=false }) => {
  return (
    <UnloadingMethodCompactWrapper>
      {title ? (
        <UnloadingMethodCompactTitle>
          {title}
        </UnloadingMethodCompactTitle>
      ) : null}
      <UnloadingImg src={imgSrc} alt={method} style={styles.img} />
    <UnloadingMethodCompactText style={styles.text}>
        {capitalize(method)}
      </UnloadingMethodCompactText>
    </UnloadingMethodCompactWrapper>
  );
};

export default UnloadingMethod;